angular.module('app.directives').directive('vpDictItem', () => ({
    restrict: 'EA',

    scope: {
        cssClass: '@',
    },

    link(scope) {
        scope.classes = [];

        if (scope.cssClass.includes('uk-badge')) {
            scope.classes.push('uk-badge');
        }

        scope.cssClass.split(' ').forEach((className) => {
            scope.classes.push(className);
        });
    },

    templateUrl: '/directives/dict-item/dict-item.html',
    transclude: true,
}));
